export default "__VITE_ASSET__Cbhq1P8P__"